/*
 * @providesModule CountriesList
 */

import React from 'react';
import {CountryListModal, CountryData} from '@skillz/ui';
import {ImageStyle} from 'react-native';

type Props = {
  visible: boolean;
  hide: () => void;
  select: (value: string) => void;
  data: CountryData[];
  getFlag: (country: string, style: ImageStyle) => React.ReactElement;
};

export function CountriesList({visible, hide, select, data, getFlag}: Props) {
  if (!visible) {
    return null;
  }

  return (
    <CountryListModal
      visible={visible}
      changeVisible={hide}
      selectCountry={select}
      data={data}
      getFlag={getFlag}
    />
  );
}
